'use client';

import React from 'react';
import styled from 'styled-components';

export interface SectionHeaderProps {
  label: string;
  action?: React.ReactNode;
  className?: string;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Label = styled.h3`
  margin: 0;
  font-size: ${(p) => p.theme.fontSize.xs};
  font-weight: ${(p) => p.theme.fontWeight.bold};
  font-family: ${(p) => p.theme.fontFamily.ui};
  color: ${(p) => p.theme.colors.neutral.inkMute};
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

export function SectionHeader({ label, action, className }: SectionHeaderProps) {
  return (
    <Wrapper className={className}>
      <Label>{label}</Label>
      {action}
    </Wrapper>
  );
}
